import {
  Menu as MenuIcon,
  NotificationsOutlined
} from "@mui/icons-material";
import { Box, IconButton, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

// assets
import Logo from "../../assets/images/dekostel.jpg";
import { useAppDispatch } from "../../hooks/useDispatch";
import ProfileMenu from "../../pages/user/Profile";
import { actions } from "../../store/reducers/global";

export default function Header() {
  const dispatch = useAppDispatch();

  return (
    <Box
      sx={(theme) => ({
        width: "100%",
        backgroundColor: "#c9ffe5",
        borderBottom: "1px solid #d3c9e0",
        position: "fixed",
        zIndex: 99,
        px: 2,
        py: 1,
        [theme.breakpoints.down("sm")]: {
          width: "100%",
          maxWidth: 768,
        },
      })}
    >
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" spacing={1}>
          <IconButton
            size="small"
            onClick={() => dispatch(actions.openSidebar())}
            sx={{ display: { lg: "none", md: "block" } }}
          >
            <MenuIcon />
          </IconButton>
          <RouterLink to="/app">
            <img alt="Logo" src={Logo} style={{ height: 48 }} />
          </RouterLink>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton size="small" component={RouterLink} to="/app/suspicious">
            <NotificationsOutlined />
          </IconButton>
          <ProfileMenu />
        </Stack>
      </Stack>
    </Box>
  );
}
